import { render, staticRenderFns } from "./modalSuporte.vue?vue&type=template&id=32a62206&scoped=true&"
import script from "./modalSuporte.vue?vue&type=script&lang=js&"
export * from "./modalSuporte.vue?vue&type=script&lang=js&"
import style0 from "./modalSuporte.vue?vue&type=style&index=0&id=32a62206&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a62206",
  null
  
)

export default component.exports